var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import "react-toastify/dist/ReactToastify.css";
import React, { useCallback, useEffect, useLayoutEffect, useState, } from "react";
import { Navigate, Route, Routes, useLocation, useSearchParams, } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
// import styles from "src/bulk-order.module.scss";
import Footer, { handleChangeForClosingValues } from "src/components/footer";
import { ReportHeightContext, StrategyContext, } from "src/contexts/custom-context";
import { BOTTOM_REPORT_TYPE, GLOBAL_DEFAULT_DATA, HEIGHT_DATA, PLAN_ID_KEY, } from "src/utils/constant";
import { SESSION_KEYS, getDataFromSession, setDataInSession, } from "./utils/session-storage";
import { closeGuestLoginModal, openBulkOrderPlacement, openFooterTab, } from "src/redux/reducers/modals";
import { getPreferences, setPreferences } from "./utils/methods";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import AppWapper from "./AppWrapper";
import BottomMenu from "./pages/dashboard/bottom-menu/bottom-menu";
import Header from "./pages/dashboard/header/header";
import Loader from "src/components/loader/loader";
import { NavPaths } from "src/config/routes";
import Showcase from "./pages/dashboard/showcase";
import SideMenu from "./pages/dashboard/side-menu/side-menu";
import SocketNotification from "./components/socket-notification/socket-notification";
import { ToastContainer } from "react-toastify";
// import StocksMenu from "./pages/dashboard/stocks-menu/stocks-menu";
import { captureApxorPageView } from "./utils/apxor";
import { defaultGreeks } from "./apis/mock/data/get-greeks";
import { getClientProfile } from "./apis/dashboard";
import { initSentry } from "src/config/sentry";
import styles1 from "src/pages/dashboard/dashboard.module.scss";
import useWindowDimensions from "./hooks/useWindowDimensions";
import FinalGuestLoginModal from "./components/final-guest-login/final-guest-login-modal";
const lazyRetry = (componentImport) => {
    return new Promise((resolve, reject) => {
        componentImport()
            .then((component) => {
            resolve(component);
        })
            .catch((err) => {
            reject(err);
        });
    });
};
const SmartOptionStrategies = React.lazy(() => import("src/pages/smart-strategies/smart-option-strategies"));
const FutureMomentum = React.lazy(() => import("src/pages/dashboard/fo-momentum/fullscreen-momentum"));
const StocksMenu = React.lazy(() => import("src/pages/dashboard/stocks-menu/stocks-menu"));
const FnoStats = React.lazy(() => lazyRetry(() => import("src/pages/fno-stats/fno-stats")));
const FullscreenFii = React.lazy(() => lazyRetry(() => import("src/pages/fullscreen-fii/fullscreen-fii")));
const Ideas = React.lazy(() => lazyRetry(() => import("src/pages/ideas/ideas")));
const OpenInterestPage = React.lazy(() => lazyRetry(() => import("src/pages/open-interest/open-interest-page")));
const LoggingConsole = React.lazy(() => import("src/pages/dashboard/logging-console"));
const OptionChainPage = React.lazy(() => lazyRetry(() => import("src/pages/option-chain/option-chain-page")));
const Scalping = React.lazy(() => import("src/pages/smart-strategies/scalping"));
const Strategies = React.lazy(() => lazyRetry(() => import("src/pages/strategies/strategies")));
const StrategiesNew = React.lazy(() => lazyRetry(() => import("src/pages/strategies/strategiesNew")));
const StockInfoPage = React.lazy(() => lazyRetry(() => import("src/pages/stock-info/stock-info-page")));
const StrategyDashboard = React.lazy(() => lazyRetry(() => import("src/pages/smart-strategies/strategie-dashboard")));
const BasketDashboardNew = React.lazy(() => import("src/components/footer/footerBasket/basketDashboardNew"));
const FooterNews = React.lazy(() => import("src/components/footer/footerNews/footerNews"));
const VttDashboard = React.lazy(() => import("src/components/footer/footerVtt/vttDashboard"));
const FooterWatchlistTab = React.lazy(() => import("src/components/footer/watchlist/footer-watchlist-tab"));
const BasketPage = React.lazy(() => import("src/pages/basketPage/basketPage"));
const OrdersPage = React.lazy(() => import("src/pages/ordersPage/ordersPage"));
const PositionPage = React.lazy(() => import("src/pages/positionsPage/positionsPage"));
const VttPage = React.lazy(() => import("src/pages/vttPage/vttPage"));
const HoldingsCdslSuccess = React.lazy(() => import("src/components/footer/footerHoldings/holdingsCdslSuccess"));
const HoldingsCdslFailure = React.lazy(() => import("src/components/footer/footerHoldings/holdingsCdslFailure"));
const StraddleChart = React.lazy(() => import("src/pages/straddle-chart/straddle-chart"));
// const BottomMenu = React.lazy(
//   () => import("src/pages/dashboard/bottom-menu/bottom-menu")
// );
// const Header = React.lazy(() => import("src/pages/dashboard/header/header"));
const OrdersDashboard = React.lazy(() => import("src/components/footer/footerOrder/ordersDashboard"));
const ExpandedPosition = React.lazy(() => import("src/components/footer/footerPosition/expandedPosition"));
const PositionDashboard = React.lazy(() => import("src/components/footer/footerPosition/positionsDashboard"));
const HoldingsDashboard = React.lazy(() => import("src/components/footer/footerHoldings/holdingsDashboard"));
const Screener = React.lazy(() => import("src/pages/dashboard/screener/screener"));
const CombinedOI = React.lazy(() => lazyRetry(() => import("src/pages/open-interest/combined-oi")));
const MultiStrikeOI = React.lazy(() => lazyRetry(() => import("src/pages/open-interest/multi-strike-oi")));
const OpenInterest = React.lazy(() => lazyRetry(() => import("src/pages/open-interest/open-interest")));
const MaxPain = React.lazy(() => lazyRetry(() => import("./pages/open-interest/max-pain")));
const CdslSuccess = React.lazy(() => lazyRetry(() => import("src/pages/redirect-cdsl/success")));
const IframeTradeTron = React.lazy(() => import("src/pages/smart-strategies/iframeTradeTron"));
const StrategyReport = React.lazy(() => import("src/pages/smart-strategies/strategy-report"));
const getElement = (comp) => {
    return _jsx(React.Suspense, Object.assign({ fallback: _jsx(Loader, {}) }, { children: comp }));
};
export const FooterModalOpenContext = React.createContext({});
const App = () => {
    const myPreferences = getPreferences();
    const [searchParams, setSearchParams] = useSearchParams();
    const isPledgeOpen = searchParams.get("pledge") !== null;
    let location = useLocation();
    const [cashScripCode, setCashScripCode] = useState(undefined);
    // const [reportHeightData, setReportHeightData] = useState<
    //   Record<string, number>
    // >({
    //   [REPORT_TYPE.ORDERBOOK_REPORT]: HEIGHT_DATA.NORMAL,
    //   [REPORT_TYPE.POSITION_REPORT]: HEIGHT_DATA.NORMAL,
    //   [REPORT_TYPE.VTT_REPORT]: HEIGHT_DATA.NORMAL,
    //   [REPORT_TYPE.BASKET_REPORT]: HEIGHT_DATA.NORMAL,
    //   [REPORT_TYPE.WATCHLIST_REPORT]: HEIGHT_DATA.NORMAL,
    //   [REPORT_TYPE.SCREENER_REPORT]: HEIGHT_DATA.NORMAL,
    //   [REPORT_TYPE.NEWS_REPORT]: HEIGHT_DATA.NORMAL,
    // });
    //clear storage on refresh with 8 hrs login check
    const [reportHeightData, setReportHeightData] = useState({
        [BOTTOM_REPORT_TYPE.LEFT_REPORT]: HEIGHT_DATA.NORMAL,
        [BOTTOM_REPORT_TYPE.RIGHT_REPORT]: HEIGHT_DATA.NORMAL,
    });
    const setReportHeightDataCallBack = (reportType, newValue) => {
        const newReportHeightData = Object.assign({}, reportHeightData);
        newReportHeightData[reportType] = newValue;
        setReportHeightData(newReportHeightData);
        myPreferences.reportHeightData.LEFT =
            reportType == BOTTOM_REPORT_TYPE.LEFT_REPORT
                ? newReportHeightData.LEFT
                : myPreferences.reportHeightData.LEFT;
        myPreferences.reportHeightData.RIGHT =
            reportType == BOTTOM_REPORT_TYPE.RIGHT_REPORT
                ? newReportHeightData.RIGHT
                : myPreferences.reportHeightData.RIGHT;
        setPreferences(myPreferences);
    };
    const setScripCodeCallback = (newObj) => {
        setCashScripCode(newObj);
    };
    // const [windowChangedTime, setWindowChangedTime] = useState<number>(0);
    const showTicker = useAppSelector((state) => state.app.showMarquee);
    const showNotification = useAppSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.modals) === null || _a === void 0 ? void 0 : _a.socketNotification; });
    const isGuestLoginModalOpen = useAppSelector((state) => state.modals.isGuestLoginModalOpen);
    const [leftModalId, setLeftModalId] = useState();
    const [rightModalId, setRightModalId] = useState();
    const { width } = useWindowDimensions();
    const openFooterTabId = useAppSelector((state) => {
        return state.modals.openFooterTabId;
    });
    const screenPadding = 0, gridGap = 6, leftMenuWidth = 0;
    const optionChainWidth = Math.floor(width - screenPadding * 2 - leftMenuWidth - gridGap * 4) / 3;
    const leftFooterModalWidth = optionChainWidth * 2 + gridGap; // 2 is extra space
    const leftFooterModalStartPoint = leftMenuWidth + screenPadding + gridGap;
    const onModalStatusChange = useCallback((tabId) => {
        const isLeftTab = tabId == "positions" ||
            tabId == "holdings" ||
            tabId == "orders" ||
            tabId == "vtt" ||
            tabId == "basket";
        const isRightTab = tabId == "watchlist" || tabId == "screener" || tabId == "news";
        if (isLeftTab) {
            if (leftModalId == tabId) {
                // if (tabId !== "orders") {
                setLeftModalId(undefined);
                // }
            }
            else {
                setLeftModalId(tabId);
            }
        }
        if (isRightTab) {
            if (rightModalId == tabId) {
                setRightModalId(undefined);
            }
            else {
                setRightModalId(tabId);
            }
        }
    }, [leftModalId, rightModalId]);
    const dispatch = useAppDispatch();
    //Storing default greeks when user first login app
    useLayoutEffect(() => {
        if (!getDataFromSession(SESSION_KEYS.GREEKSLIST))
            setDataInSession(SESSION_KEYS.GREEKSLIST, defaultGreeks(), true);
        if (!getDataFromSession(SESSION_KEYS.GLOBAL_SETTINGS))
            setDataInSession(SESSION_KEYS.GLOBAL_SETTINGS, GLOBAL_DEFAULT_DATA, true);
    }, []);
    useEffect(() => {
        if (openFooterTabId) {
            onModalStatusChange(openFooterTabId);
            dispatch(openFooterTab(undefined));
        }
    }, [openFooterTabId]);
    useEffect(() => {
        let params = new URLSearchParams(location.search);
        let bulkOrderData = params.get("bulkOrderData");
        if (bulkOrderData) {
            let decodedBulkOrderData = decodeURIComponent(bulkOrderData);
            let parsedBulkOrderData = JSON.parse(decodedBulkOrderData);
            dispatch(openBulkOrderPlacement(parsedBulkOrderData));
        }
    }, []);
    const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
    const getClientInfoCallback = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield getClientProfile();
            if (response.data.body.Status == 0) {
                setDataInSession(SESSION_KEYS.PLAN_ID, response.data.body[PLAN_ID_KEY]);
            }
        }
        catch (error) {
            console.error(error);
        }
    });
    const onSearchFocus = useCallback(() => {
        setLeftModalId(undefined);
        setRightModalId(undefined);
        handleChangeForClosingValues("leftTab", leftModalId);
        handleChangeForClosingValues("rightTab", rightModalId);
    }, [leftModalId, rightModalId]);
    useEffect(() => {
        initSentry();
        if (isPledgeOpen) {
            setLeftModalId("holdings");
        }
        if (clientCode) {
            getClientInfoCallback();
            try {
                if (window.clevertap && window.clevertap.onUserLogin) {
                    window.clevertap.onUserLogin.push({
                        Site: {
                            Identity: clientCode, // String or number
                        },
                    });
                }
            }
            catch (error) {
                console.error(error);
            }
        }
    }, []);
    useEffect(() => {
        setDataInSession(SESSION_KEYS.PREFERENCE_CHANGED, "false", true);
    }, []);
    useEffect(() => {
        const pathName = window.location.pathname === "/"
            ? "/dashboard"
            : window.location.pathname;
        captureApxorPageView(pathName);
    }, [window.location.pathname]);
    // making a recursive call for set preference aftere an interval
    const getLeftModalData = useCallback(() => {
        // dispatch(openFooterModal(leftModalId));
        switch (leftModalId) {
            case "positions":
                return (_jsx(React.Suspense, Object.assign({ fallback: _jsx(Loader, {}) }, { children: _jsx(PositionDashboard, { onModalClose: () => onModalClose(leftModalId) }) })));
            case "holdings":
                return (_jsx(React.Suspense, Object.assign({ fallback: _jsx(Loader, {}) }, { children: _jsx(HoldingsDashboard, { isPledge: isPledgeOpen, onModalClose: () => onModalClose(leftModalId) }) })));
            case "orders":
                return (_jsx(React.Suspense, Object.assign({ fallback: _jsx(Loader, {}) }, { children: _jsx(OrdersDashboard, { onModalClose: () => onModalClose(leftModalId) }) })));
            case "vtt":
                return (_jsx(React.Suspense, Object.assign({ fallback: _jsx(Loader, {}) }, { children: _jsx(VttDashboard, { onModalClose: () => onModalClose(leftModalId) }) })));
            case "basket":
                return (_jsx(React.Suspense, Object.assign({ fallback: _jsx(Loader, {}) }, { children: _jsx(BasketDashboardNew, { onModalClose: () => onModalClose(leftModalId) }) })));
            default:
                return null;
        }
    }, [leftModalId]);
    const onOverlayClick = useCallback(() => {
        const footerTabIds = [
            "positions",
            "holdings",
            "orders",
            "vtt",
            "basket",
            "watchlist",
            "screener",
            "news",
        ];
        footerTabIds.map((data) => {
            const element = document.getElementById(data);
            if (element === null || element === void 0 ? void 0 : element.classList.contains("activeTab")) {
                element === null || element === void 0 ? void 0 : element.classList.toggle("activeTab");
            }
        });
        setLeftModalId(undefined);
        setRightModalId(undefined);
    }, []);
    const onModalClose = useCallback((tabId) => {
        const isLeftTab = tabId == "positions" ||
            tabId == "holdings" ||
            tabId == "orders" ||
            tabId == "vtt" ||
            tabId == "basket";
        const isRightTab = tabId == "watchlist" || tabId == "screener" || tabId == "news";
        if (isLeftTab) {
            setLeftModalId(undefined);
        }
        if (isRightTab) {
            setRightModalId(undefined);
        }
    }, []);
    const getRightModalData = useCallback(() => {
        // dispatch(openFooterModal(rightModalId));
        switch (rightModalId) {
            case "watchlist":
                return (_jsx(React.Suspense, Object.assign({ fallback: _jsx(Loader, {}) }, { children: _jsx(FooterWatchlistTab, { onModalClose: () => onModalClose(rightModalId) }) })));
            case "screener":
                return (_jsx(React.Suspense, Object.assign({ fallback: _jsx(Loader, {}) }, { children: _jsx(Screener, { onModalClose: () => onModalClose(rightModalId) }) })));
            case "news":
                return (_jsx(React.Suspense, Object.assign({ fallback: _jsx(Loader, {}) }, { children: _jsx(FooterNews, { onModalClose: () => onModalClose(rightModalId) }) })));
            default:
                return null;
        }
    }, [rightModalId]);
    const getReportHeight = (reportType) => {
        const height = reportHeightData[reportType];
        if (height == undefined) {
            return HEIGHT_DATA.NORMAL;
        }
        else {
            return height;
        }
    };
    const footerReportType = (modalId) => {
        let reportType;
        switch (modalId) {
            case "positions":
                reportType = BOTTOM_REPORT_TYPE.LEFT_REPORT;
                break;
            case "holdings":
                reportType = BOTTOM_REPORT_TYPE.LEFT_REPORT;
                break;
            case "orders":
                reportType = BOTTOM_REPORT_TYPE.LEFT_REPORT;
                break;
            case "vtt":
                reportType = BOTTOM_REPORT_TYPE.LEFT_REPORT;
                break;
            case "basket":
                reportType = BOTTOM_REPORT_TYPE.LEFT_REPORT;
                break;
            default:
                break;
        }
        switch (modalId) {
            case "watchlist":
                reportType = BOTTOM_REPORT_TYPE.RIGHT_REPORT;
                break;
            case "screener":
                reportType = BOTTOM_REPORT_TYPE.RIGHT_REPORT;
                break;
            case "news":
                reportType = BOTTOM_REPORT_TYPE.RIGHT_REPORT;
                break;
            default:
                break;
        }
        return reportType;
    };
    const getLeftModalClassName = () => {
        let classname = "";
        if (getReportHeight(footerReportType(leftModalId)) == HEIGHT_DATA.EXPANDED) {
            if (showTicker) {
                classname = "expandHeightTicker";
            }
            else {
                classname = "expandHeight";
            }
        }
        return classname;
    };
    const getRightModalClassName = () => {
        let classname = "";
        if (getReportHeight(footerReportType(rightModalId)) == HEIGHT_DATA.EXPANDED) {
            if (showTicker) {
                classname = "expandHeightTicker";
            }
            else {
                classname = "expandHeight";
            }
        }
        return classname;
    };
    useEffect(() => {
        const hasVerticalScrollbar = document.body.scrollHeight > window.innerHeight;
        if (hasVerticalScrollbar && isGuestLoginModalOpen) {
            document.body.style.overflowY = "scroll";
            document.body.style.paddingRight = "0px";
        }
        else {
            document.body.style.overflowY = "auto";
        }
    }, [isGuestLoginModalOpen]);
    return (_jsxs(_Fragment, { children: [_jsx(AppWapper, {}), showNotification && _jsx(SocketNotification, {}), _jsx(StrategyContext.Provider, Object.assign({ value: {
                    cashScripObject: cashScripCode,
                    setCashScripObject: setScripCodeCallback,
                } }, { children: _jsx(ReportHeightContext.Provider, Object.assign({ value: {
                        reportHeightData: reportHeightData,
                        addReportData: setReportHeightDataCallBack,
                    } }, { children: _jsx(FooterModalOpenContext.Provider, Object.assign({ value: { onModalStatusChange } }, { children: _jsxs("div", Object.assign({ className: styles1.wrapper }, { children: [_jsxs("div", Object.assign({ className: styles1.mainHeader }, { children: [_jsx(Header, { onSearchFocus: onSearchFocus }), showTicker == true ? (_jsx("div", Object.assign({ className: `${styles1.subHeader}` }, { children: _jsx("div", Object.assign({ className: styles1.stocksMenuWrapper }, { children: getElement(_jsx(StocksMenu, {})) })) }))) : ("")] })), _jsxs("div", Object.assign({ className: `${styles1.mainContent} d-flex mt-2` }, { children: [_jsx(SideMenu, {}), _jsxs("div", Object.assign({ className: `${styles1.showcase}` }, { children: [_jsxs(Routes, { children: [_jsx(Route, { path: "*", element: _jsx(Navigate, { to: NavPaths.home, replace: true }) }), _jsx(Route, { path: NavPaths.home, element: getElement(_jsx(Showcase, {})) }), _jsx(Route, { path: NavPaths.randomPath, element: getElement(_jsx(LoggingConsole, {})) }), _jsx(Route, { path: NavPaths.dashboard, element: getElement(_jsx(Showcase, {})) }), _jsx(Route, { path: NavPaths.chain, element: getElement(_jsx(OptionChainPage, {})) }), _jsx(Route, { path: NavPaths.stockInfo, element: getElement(_jsx(StockInfoPage, {})) }), _jsx(Route, { path: NavPaths.fiiDii, element: getElement(_jsx("div", { children: _jsx(FullscreenFii, {}) })) }), _jsxs(Route, Object.assign({ path: NavPaths.openInterest.index, element: getElement(_jsx(OpenInterestPage, {})) }, { children: [_jsx(Route, { path: "*", element: _jsx(Navigate, { to: NavPaths.openInterest.index, replace: true }) }), _jsx(Route, { index: true, element: getElement(_jsx(OpenInterest, {})) }), _jsx(Route, { path: NavPaths.openInterest.oiDashboard, element: getElement(_jsx(OpenInterest, {})) }), _jsx(Route, { path: NavPaths.openInterest.combineOI, element: getElement(_jsx(CombinedOI, {})) }), _jsx(Route, { path: NavPaths.openInterest.multiStrikeOI, element: getElement(_jsx(MultiStrikeOI, {})) }), _jsx(Route, { path: NavPaths.openInterest.maxPain, element: getElement(_jsx(MaxPain, {})) })] })), _jsx(Route, { path: `${NavPaths.fnoStats.index}/*`, element: getElement(_jsx(FnoStats, {})) }), _jsx(Route, { path: `${NavPaths.ideas.index}/*`, element: getElement(_jsx(Ideas, {})) }), _jsx(Route, { path: NavPaths.StrategyReport, element: getElement(_jsx(StrategyReport, {})) }), _jsx(Route, { path: NavPaths.Positions, element: getElement(_jsx(PositionPage, {})) }), _jsx(Route, { path: NavPaths.Orders, element: getElement(_jsx(OrdersPage, {})) }), _jsx(Route, { path: "/vtt", element: getElement(_jsx(VttPage, {})) }), _jsx(Route, { path: "/basket", element: getElement(_jsx(BasketPage, {})) }), _jsx(Route, { path: NavPaths.momentum, element: getElement(_jsx(FutureMomentum, {})) }), _jsx(Route, { path: NavPaths.predefined, element: getElement(_jsx(Strategies, {})) }), _jsx(Route, { path: "/preStrategyV1", element: getElement(_jsx(StrategiesNew, {})) }), _jsx(Route, { path: "/redirect-cdsl/success", element: _jsx(Navigate, { to: NavPaths.home }) }), _jsx(Route, { path: "/redirect-cdsl/failure", element: _jsx(Navigate, { to: NavPaths.home }) }), _jsx(Route, { path: "/ideas", element: _jsx(Navigate, { to: NavPaths.ideas.Equity }) }), _jsx(Route, { path: "/cdslsuccess", element: getElement(_jsx(HoldingsCdslSuccess, {})) }), _jsx(Route, { path: "/cdslfailure", element: getElement(_jsx(HoldingsCdslFailure, {})) }), _jsx(Route, { path: "/multi-straddle-strangle-chart", element: getElement(_jsx(StraddleChart, {})) })] }), _jsx(Footer, { leftModalId: leftModalId, rightModalId: rightModalId, leftFooterModalWidth: leftFooterModalWidth, onModalStatusChange: onModalStatusChange })] }))] })), _jsx(BottomMenu, {}), _jsx(React.Suspense, Object.assign({ fallback: _jsx(_Fragment, {}) }, { children: _jsx(CdslSuccess, {}) })), _jsxs(_Fragment, { children: [(leftModalId || rightModalId) && (_jsxs("div", Object.assign({ className: styles1.overlay, onClick: onOverlayClick }, { children: [Boolean(leftModalId) && (_jsx("div", Object.assign({ onClick: (e) => e.stopPropagation(), style: {
                                                        left: leftFooterModalStartPoint,
                                                        width: leftFooterModalWidth - 3,
                                                        bottom: 44,
                                                    }, className: `${styles1.leftFooterModal} 
                              ${getLeftModalClassName()} leftFooterModal ` }, { children: getLeftModalData() }))), Boolean(rightModalId) && (_jsx("div", Object.assign({ onClick: (e) => e.stopPropagation(), style: {
                                                        right: screenPadding + gridGap,
                                                        width: optionChainWidth - 2,
                                                        bottom: 44,
                                                    }, className: `${styles1.rightFooterModal} ${getRightModalClassName()} rightFooterModal` }, { children: getRightModalData() })))] }))), _jsx(FinalGuestLoginModal, { show: isGuestLoginModalOpen, onHide: () => dispatch(closeGuestLoginModal()) })] }), _jsx(ToastContainer, { position: "bottom-right", autoClose: 2000 })] })) })) })) }))] }));
};
export default App;
